import ApiService from '../api/ApiService';
import Config from '../constants/Config';
import Urls from '../api/Urls';
import Homestay from '../models/Homestay';
import Reservation from '../models/Reservation';
import TagGroupDetail from '../models/TagGroupDetail';

import { HOMESTAY } from '../constants/Define';
import { getDummyData } from '../utils/commonUtils';
import RateCompare from 'models/RateCompare';

export function getAllHomestays(params) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_ALL,
        params: params,
        parser: homestaysAllDataParser,
    }).get();
}

export function getAllHomestaysActive(params) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_ALL_ACTIVE,
        params: params
    }).get();
}

export function getHomestays(params) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_LIST,
        params: params,
        parser: homestaysDataParser,
    }).get();
}

export function getHomestayDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_DETAIL,
        endpointParams: { id },
        parser: (data) => new Homestay(data.hotel),
    }).get();
}

export function createHomestayDetail(homestay) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_CREATE,
        parser: (data) => new Homestay(data.hotels),
    }).post({ hotel: homestay.export() });
}

export function updateHomestayDetail(homestay) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_DETAIL,
        endpointParams: { id: homestay.id },
        parser: (data) => new Homestay(data.homestay),
    }).put({ hotel: homestay.export() });
}

export function getHomestayBooking(productVariantIds = []) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_BOOKING_DETAIL,
        parser: (data) => (data.reservations || []).map(item => new Reservation(item)),
    }).post(productVariantIds);
}

export function createHomestayTranslate(homestay) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_TRANSLATE_CREATE,
    }).post(homestay.export(true).translate());
}

export function updateHomestayTranslate(homestay) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_TRANSLATE_UPDATE,
    }).put(homestay.export(true).translate());
}

export function deleteHomestayTranslate(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getCrossSellBooking(productVariantIds = []) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.CROSSSELL_BOOKING_DETAIL,
        parser: (data) => (data.data.reservations || []).map(item => new Reservation(item)),
    }).post(productVariantIds);
}

export function getTagroupDetailSKU(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.HOMESTAY_TAGGROUP_DETAIL_SKU,
        endpointParams: { id },
        params: { //hard code load homestay
            groupType: 3,
            tagType: 2,
            skuType: 7
        },
        parser: (data) => (data.data || []).map(item => new TagGroupDetail(item))
    }).get();
}

export function updateTagroupDetailSKUActive(tagsGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.HOMESTAY_TAGGROUP_DETAIL_SKU_ACTIVE,
    }).put(tagsGroup);
}

const homestaysDataParser = (data) => ({
    homestays: (data.hotels || []).map(item => new Homestay(item)),
    pageIndex: Math.floor(data.offset / data.limit) + 1,
    pageSize: data.limit,
    totalCount: data.total
});
const homestaysAllDataParser = (data) => {
    return (data || []).map(item => new Homestay(item))
};

const getHomestayItem = (i) => new Homestay({
    id: i,
    name: 'Homestay name ' + (i + 1),
    code: `CODE${i}`,
    shortDescription: `Short Description ${i + 1}`,
    description: `Description ${i + 1}`,
    types: [(i % 4 == 0 ? HOMESTAY.TYPE.VILLA : i % 3 === 0 ? HOMESTAY.TYPE.CONDOTEL : i % 2 === 0 ? HOMESTAY.TYPE.RESORT : HOMESTAY.TYPE.APARTMENT)],
    address: `Address ${i + 1}`,
    province: 'Province 1',
    country: 'Việt Nam',
    locationId: i,
    lat: 10.7797855,
    lng: 106.6990189,
    star: i % 5 + 1,
    hotline: `09231443 ${i + 1}`,
    review: i + 10,
    refId: i,
    media: [{ url: 'placeimg.com/200/200/any', order: 0 }],
    isActive: i % 2 === 0,
});

const getDummyHomestays = (pageSize = 10, pageIndex = 1) => {
    const result = getDummyData(pageSize, pageIndex, getHomestayItem);
    return { ...result, homestays: result.data };
}

export function clearCache(params) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_RESET_CACHE,
        params: params,
    }).get();
}

export function getRateCompare(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_COMPARE_RATE,
        params: data,
        parser: (data) => new RateCompare(data.result),
    }).get();
}

export function createRateCompare(data) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_COMPARE_RATE,
        parser: (data) => new RateCompare(data),
    }).post(data);
}

export function updateRateCompare(data) {
    const id = data.id;
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_COMPARE_RATE_DETAIL,
        endpointParams: { id },
        parser: (data) => new RateCompare(data),
    }).put(data.dataRateCompare);
}

export function deleteRateCompare(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_COMPARE_RATE_DETAIL,
        endpointParams: { id }
    }).delete()
}
